import cx from 'classnames';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

// components
import EmptyTable from './EmptyTable';

// internal
import { get_directory_slug } from '../election-utils';

const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  contestTitle: string;
  includeCountyRundown?: boolean;
  isShowcaseRace?: boolean;
  renderParty: any;
  renderCandidate: any;
  embedType: string;
  broadcastHeaderImage: string;
  activeContestId: string;
  showContestTitleInShowcase?: boolean;
  hideEmptyParty?: boolean;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      isShowcaseRace,
      showContestTitleInShowcase,
      renderParty,
      hideEmptyParty,
    } = this.props;

    const onePrimary = contest.length == 1;

    let onePrimaryParty;

    if (onePrimary) {
      onePrimaryParty = contest[0].party;
    }

    const rowClass = cx({
      seat__races: !isShowcaseRace,
      seat__highlight_races: isShowcaseRace,
    });

    let directory_slug;

    if (contest[0]) {
      directory_slug = get_directory_slug(contest[0].office);
    }

    return (
      <div class="seat">
        {!isShowcaseRace && (
          <h3 class="seat__title">
            <span>{contestTitle}</span>
            {/* Let's not show U.S. House directory links because the redistricting boundaries have changed and will be reflected in our directory in 2027 */}
            {directory_slug[0] != null && contest[0].office != 'U.S. House'  && (
              <a
                class="t-links-unset"
                href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contest[0]['office_division']}`}
              >
                <span class="icon-div" title="Click to learn more about this district" >
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
          </h3>
        )}
        <div class={rowClass}>
          {onePrimary &&
            onePrimaryParty == 'Republican' &&
            !isShowcaseRace &&
        !hideEmptyParty && <EmptyTable party={'Democrat'} />}


          {!isShowcaseRace &&
        contest.map((party: any, index) => renderParty(party, index))}

          {isShowcaseRace && (
            <div>
              {showContestTitleInShowcase && (
                <h3 class="seat__title">
                  <span>{contest.office}</span>
                </h3>
              )}
              {renderParty(contest)}
            </div>
          )}
          {onePrimary &&            onePrimaryParty == 'Democrat' &&
            !isShowcaseRace &&
            !hideEmptyParty && <EmptyTable party={'Republican'} />}
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
};

export default Contest;
